import { render, staticRenderFns } from "./PasswordResetPage.vue?vue&type=template&id=3e493600&"
import script from "./PasswordResetPage.vue?vue&type=script&lang=ts&"
export * from "./PasswordResetPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e493600')) {
      api.createRecord('3e493600', component.options)
    } else {
      api.reload('3e493600', component.options)
    }
    module.hot.accept("./PasswordResetPage.vue?vue&type=template&id=3e493600&", function () {
      api.rerender('3e493600', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Auth/PasswordResetPage.vue"
export default component.exports